import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationInsightsModule } from '@markpieszak/ng-application-insights';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from '@pg-app/app-routing.module';
import { AppComponent } from '@pg-app/core/containers/app.component';
import { CoreModule } from '@pg-app/core/core.module';
import { HttpLoaderFactory, LocalizationService } from '@pg-app/core/services/localization.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ToastrModule } from 'ngx-toastr';
import { GtagModule } from 'angular-gtag';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { environment } from '@pg-env/environment';
import { ServiceWorkerModule } from '@angular/service-worker';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule,
    AppRoutingModule,
    NgxMatSelectSearchModule,
    NgIdleKeepaliveModule.forRoot(),
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 20000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      enableHtml: true
    }),
    ApplicationInsightsModule.forRoot({
      instrumentationKeySetLater: true
    }),
    GtagModule.forRoot({ trackingId: 'UA-122808794-2', trackPageviews: true }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.checkVersion }),
  ],
  providers: [
    LocalizationService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptchaV2SiteKey} as RecaptchaSettings
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
